import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeRequest } from 'Douleutaras/services/apiClient';

const STATS_INTRO_API = 'api/public/v3/stats/intro';

export interface StatsIntro {
  jobs_assigned: number;
  revenue: string;
  reviews: string;
  quotes_sent: 0;
  credits_cnt: string;
  mary_score: string;
  jobs: number;
  user_salesforce_status: string;
}

export const getStatsIntro = createAsyncThunk<StatsIntro>(
  'stats/intro/get',
  async (args, api) => {
    const response = await makeRequest(
      `${STATS_INTRO_API}/`,
      {
        method: 'GET'
      }
    )(api);

    return response.data.data;
  }
);
